import { Loading } from "@/app/components/LoadingFilters";

export const LoadingSearch = () => <Loading className="h-6 w-48" />;
